import { AugmentedStore } from 'ia-react-core/~/interfaces/AugmentedStore';
import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import reduceNamespace from './reduceNamespace';
import { INIT_NESTED_REDUCERS } from './withStore.constants';

export default function initializeReducers<State extends object>(store: AugmentedStore<State>, state: State, action: CoreAction, changes: string[]) {
  const { uninitializedReducers } = store.injectedReducers;

  if (!uninitializedReducers.length) {
    return state;
  }

  const initAction = { type: INIT_NESTED_REDUCERS };
  const initializedState = reduceNamespace(state, initAction, uninitializedReducers, changes);

  // Redux actions are invoked just for testing, we must make sure we initialize on a real action
  if (!action.type.startsWith('@@redux')) {
    store.injectedReducers.uninitializedReducers = [];
  }

  return initializedState;
}
